<template>
    <div>
        <div class="form-group">
            <label>{{ lng.cat_vessel_type}}</label>
            <select v-model="dataRequest.pvt" @change="getVesselsType">
                <option v-for="vt in parentVesselsType"
                        :value="vt.id" v-text="vt.name"
                ></option>
            </select>
        </div>

        <div class="form-group" v-if="vesselsType.length">
            <label>{{ lng.vessel_type}}</label>
            <select v-model="dataRequest.vessel"
                    @change="initRequest">
                <option v-for="item in flatted"
                        :value="item.id" v-text="item.name"
                ></option>
            </select>
        </div>

    </div>
</template>

<script>
import axios from 'axios';
import {mapActions, mapGetters} from 'vuex';
import {flat, getParentId, createOverlay, removeOverlay} from '../../plugins/utils';

export default {


    data(){
        return {
            initValue: -1
        }
    },
   computed: {
    ...mapGetters([
         'lng',
          'parentVesselsType',
          'selectedVT',
          'vesselsType',
           'dataRequest'
          ]),

          flatted(){
              return flat(this.vesselsType)
            }
   },
   methods: {
        ...mapActions([
          'setSelectedVT',
          'setVesselsType',
          'prepareRequest',
          'sendRequest'
         ]),

         getVesselsType(){
            this.setSelectedVT({key: 'vt', val: 0});
            this.prepareRequest({key: 'vessel', val:0});
            createOverlay();
            axios.post(url + '/vacancies', {
                action: "getVesselsType",
                id: this.dataRequest.pvt
            })
            .then(response =>  {
                removeOverlay();
                this.setVesselsType(response.data.vessels)
              }).catch(err => removeOverlay());
         },
         initRequest(){

           var vt = this.selectedVT.vt;
           var selectVT = this.dataRequest.vessel;
           var el = this.flatted.filter(function(item){
               return item.id===selectVT;
           }).shift();
           if(el!==undefined && el.children!==undefined){
               var ids = [];
               el.children.map(function(item){
                   if(item.children!==undefined){
                       var subIds = item.children.map(function(subchild){
                           return ids.push(subchild.id);
                       });
                       ids.push(item.id);
                       return subIds;
                   }
                   return ids.push(item.id);
               });
               this.dataRequest.vessel = ids;
           }
            this.setSelectedVT({key: 'vt', val: this.dataRequest.vessel});
            this.sendRequest();
         }
   }
}



</script>



// WEBPACK FOOTER //
// VesselsType.vue?d7f4c594